import { makeObservable, observable } from 'mobx'
import type { SchoolGrade } from 'src/dto/Student'

import { DTO } from '../DTO'

export type FavoriteProblem = res.FavoriteProblemTree['relationList'][number]['problemList'][number]

export class FavoriteProblemTree extends DTO {
  curriculumId: number
  curriculumName: string
  schoolType: SchoolGrade['schoolType']
  revision: common.Revision
  relationList: {
    curriculumId: number
    curriculumName: string
    problemList: FavoriteProblem[]
  }[] = []

  grandChild: {
    id: number
    type: common.ProblemType
    level: common.ProblemLevel
    rate: number
    conceptName: string
    problemImageUrl: string
    answerImageUrl: string
    solutionImageUrl: string
  }[] = []

  constructor(data: res.FavoriteProblemTree) {
    super()
    this.curriculumId = data.curriculumId
    this.curriculumName = data.curriculumName
    this.relationList = data.relationList
    this.schoolType = data.schoolType
    this.revision = data.revision

    makeObservable(this, {
      curriculumId: observable,
      curriculumName: observable,
      relationList: observable,
      grandChild: observable,
      schoolType: observable,
      revision: observable,
    })
  }
}
